import React, { useState } from 'react';
import { ChevronDownIcon, MessageCircleIcon } from 'lucide-react';
import Button from '../ui/Button';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const FAQ = () => {
  const {
    t,
    language
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const whatsappLink = getWhatsAppLink(t.faq.whatsappMsg);
  return <section className="py-16 px-4 bg-sand-50" data-id="element-124">
      <div className="container mx-auto max-w-3xl" data-id="element-125">
        <div className="text-center mb-10" data-id="element-126">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-primary mb-4" data-id="element-127">
            {t.faq.headline}
          </h2>
          <p className="text-gray-600" data-id="element-128">{t.faq.subheadline}</p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-129">
          {t.faq.items.map((faq, index) => <div key={index} className={`bg-white rounded-xl border transition-all duration-300 ${openIndex === index ? 'border-success shadow-md' : 'border-gray-200'}`} data-id="element-130">
              <button className="w-full flex justify-between items-center p-5 text-left focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-131">
                <span className={`font-bold text-lg ${openIndex === index ? 'text-primary' : 'text-gray-700'}`} data-id="element-132">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180 text-success' : 'text-gray-400'}`} data-id="element-133" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-134">
                <div className="p-5 pt-0 text-gray-600 leading-relaxed border-t border-gray-100 mt-2" data-id="element-135">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-white p-8 rounded-2xl shadow-sm border border-sand-200" data-id="element-136">
          <h3 className="font-bold text-xl text-primary mb-2" data-id="element-137">
            {t.faq.ctaTitle}
          </h3>
          <p className="text-gray-600 mb-6" data-id="element-138">{t.faq.ctaText}</p>
          <Button href="#lead-form" variant="success" className="bg-[#25D366] hover:bg-[#20bd5a]" onClick={() => trackContact({
          location: 'faq_section',
          language,
          action: 'scroll_to_form'
        })} data-id="element-139">
            <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-140" />
            {t.faq.ctaButton}
          </Button>
        </div>
      </div>
    </section>;
};
export default FAQ;